(function () {
  function navTypeFromLevel(level) {
    if (level === 'secondary') return 'Secondary';
    if (level === 'tertiary') return 'Tertiary';
    return 'Primary';
  }

  function navDataFromElement(el) {
    var level = el.dataset.navTrack;
    var data = {
      primary_link: el.dataset.primaryLink || '',
      primary_link_text: el.dataset.primaryLinkText || '',
      secondary_link: el.dataset.secondaryLink || '',
      secondary_link_text: el.dataset.secondaryLinkText || '',
      tertiary_link: el.dataset.tertiaryLink || '',
      tertiary_link_text: el.dataset.tertiaryLinkText || '',
    };

    if (level === 'tertiary') {
      data.tertiary_link = data.tertiary_link || el.getAttribute('href') || '';
      data.tertiary_link_text = data.tertiary_link_text || el.textContent.trim() || '';
    }

    return data;
  }

  function initHeaderNavTracking(header) {
    if (!header || header.dataset.navTrackingInit === 'true') return;
    header.dataset.navTrackingInit = 'true';

    header.addEventListener('click', function (event) {
      if (typeof window.nc !== 'function') return;

      var trackable = event.target.closest('[data-nav-track]');
      if (!trackable) return;

      window.nc(navTypeFromLevel(trackable.dataset.navTrack), navDataFromElement(trackable));
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    initHeaderNavTracking(document.querySelector('.section-header'));
  });
})();
